// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2mA7b","content":"RecentSearches_content__1MPXd"};